import { useModal } from "../contexts";
import { BLOCK_ICON_MAP, BLOCK_NAME_MAP } from "../utils";
import ProLabel from "./ProLabel";
import PayWallModalPro from "./PayWallModalPro";
import BetaLabel from "./BetaLabel";
import WorkflowModalHubspotObjects from "./WorkflowModalHubspotObjects";

interface BaseProps {
  title: string;
  subtitle: string;
  onSelection: (blockType: string, primaryObject: string) => void;
  beta?: boolean;
}

interface NonProProps extends BaseProps {
  pro?: false;
}

interface ProProps extends BaseProps {
  pro: true;
  hasProFeature: boolean;
}


type Props = NonProProps | ProProps;

function WorkflowSelectHubspotButton(props: Props) {
  const { openModal } = useModal();

  function createBlock(selectedObjectId: string) {
    if (!selectedObjectId)
      return;

    if (props.pro && !props.hasProFeature)
      openModal(<PayWallModalPro />);
    else
      props.onSelection("HUBSPOT", selectedObjectId);
  }

  return (
    <div tabIndex={0} className={`flex flex-shrink-0 items-center border-2 border-gray-200 rounded cursor-pointer px-8  hover:border-blue`} onClick={() => openModal(<WorkflowModalHubspotObjects onSelect={createBlock} />)}>
      <img className="w-12 h-12 my-4" src={BLOCK_ICON_MAP["HUBSPOT"]} alt={BLOCK_NAME_MAP["HUBSPOT"]} />
      <div className="flex flex-col items-start ml-4">
        <div className="font-gilroy font-semibold text-lg text-gray-600">
          {props.title}
        </div>
        <div className="font-gilroy font-semibold text-sm text-gray-400">
          {props.subtitle}
        </div>
      </div>
      {props.pro && <ProLabel />}
      {props.beta && <BetaLabel />}
    </div>
  );
}

export default WorkflowSelectHubspotButton;
